export const PROFILE_SHOW_TABS = [
  'profile',
  'favorites',
  'collections',
  'progressions',
  'sessions',
  'cycles',
  'reviews',
] as const;
export type ProfileShowTab = (typeof PROFILE_SHOW_TABS)[number];
export const PROFILE_DEFAULT_TAB: ProfileShowTab = 'profile';
